// Cache one Intl.NumberFormat per (currency, locale) — constructing it is
// expensive and formatCurrency is called once per line-item cell.
const formatterCache = new Map<string, Intl.NumberFormat>();

const getFormatter = (currency: string, locale: string): Intl.NumberFormat => {
  const key = `${locale}:${currency}`;
  let formatter = formatterCache.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    formatterCache.set(key, formatter);
  }
  return formatter;
};

export const formatCurrency = (cents: number, currency = 'AUD', locale = 'en-AU'): string =>
  getFormatter(currency, locale).format(Number.isFinite(cents) ? cents / 100 : 0);

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) {
    return '';
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  const day = String(d.getDate()).padStart(2, '0');
  const month = months[d.getMonth()] ?? '';
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
};

/**
 * Lowercase a unit string and naively pluralise when quantity != 1.
 * Display-only; does not handle irregular plurals.
 */
export const formatUnit = (unit: string, quantity?: number): string => {
  const lowered = (unit ?? '').toLowerCase().trim();
  if (lowered === '') {
    return '';
  }
  if (quantity === undefined || quantity === 1) {
    return lowered;
  }
  if (lowered.endsWith('s')) {
    return lowered;
  }
  return `${lowered}s`;
};
